import { render, staticRenderFns } from "./davulge_AjTeam.vue?vue&type=template&id=976b9538&scoped=true&"
import script from "./davulge_AjTeam.vue?vue&type=script&lang=js&"
export * from "./davulge_AjTeam.vue?vue&type=script&lang=js&"
import style0 from "./davulge_AjTeam.vue?vue&type=style&index=0&id=976b9538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976b9538",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
